import axios from "axios";

export const listCategoryProducts = async () => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/list-category-products`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const FilterProductByWeight = async (minWeight, maxWeight) => {
  try {
    return await axios.get(
      `${process.env.REACT_APP_API_URL_ZIYA}/api/auth/filter-products-weight/${minWeight}/${maxWeight}`
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};
